// extracted by mini-css-extract-plugin
export default {"brandPromo":"NE-z","carousel":"OE-z"};